import Vue from "vue";
import VueRouter from "vue-router";
import LandingView from "../views/LandingView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: LandingView,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/blogs",
    name: "Blogs",
    component: () =>
      import(/* webpackChunkName: "blogs" */ "../views/BlogsView.vue"),
      // TODO: implement the following:
      // only show a snippet of the blog
      // have a link titled 'continue'
      // when users click on it, the title will passed as a param
      // and the router will make a get request to pull the data
      // https://stackoverflow.com/questions/40382388/how-to-set-url-query-params-in-vue-with-vue-router
  },
  {
    path: "/links",
    name: "Links",
    component: () =>
      import(/* webpackChunkName: "links" */ "../views/LinksView.vue"),
  },
  {
    path: "/blog/:id/:title",
    name: "Blog",
    component: () =>
      import(/* webpackChunkName: "blog" */ "../views/BlogView.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
